export default {"name":"NovaComponents-TextArea-gui-icu","NovaComponents-TextArea-gui-icu.invalidInput.label":"Invalid input: {message}"}